import { encode, decode } from '@nem035/gpt-3-encoder';
import _ from 'lodash';

/** Get the number of tokens  */
function getTokenCount(text) {
  const tokens = encode(text);
  return tokens.length;
}

/** Returns a trimmed version of `text` that only includes the first `k` tokens. */
const getFirstKTokens = (text, k) => {
  const tokens = encode(text);
  const firstKTokens = tokens.slice(0, k);
  return _.reduce(firstKTokens, (acc, token) => acc + decode([token]), '');
};

export { getTokenCount, getFirstKTokens };
